/** Impl dos use cases do calendário + ciclo Agendamento. @since G.5.10 */
import type { Page } from '@/domain/model/Page';
import type {
  Agendamento, CancelarAgendamentoCommand, CriarAgendamentoCommand,
} from '@/domain/model/Agendamento';
import type {
  AgendamentoGateway, CalendarioParams,
} from '@/application/port/out/AgendamentoGateway';
import type {
  ListCalendarioUseCase, GetAgendamentoUseCase, CriarAgendamentoUseCase,
  ConfirmarAgendamentoUseCase, MarcarAgendamentoRealizadoUseCase,
  MarcarAgendamentoNoShowUseCase, CancelarAgendamentoUseCase,
} from '@/application/port/in/AgendamentoUseCase';

export class ListCalendario implements ListCalendarioUseCase {
  constructor(private readonly g: AgendamentoGateway) {}
  execute(params: CalendarioParams): Promise<Page<Agendamento>> { return this.g.calendario(params); }
}
export class GetAgendamento implements GetAgendamentoUseCase {
  constructor(private readonly g: AgendamentoGateway) {}
  execute(id: string): Promise<Agendamento> { return this.g.get(id); }
}
export class CriarAgendamento implements CriarAgendamentoUseCase {
  constructor(private readonly g: AgendamentoGateway) {}
  execute(cmd: CriarAgendamentoCommand): Promise<Agendamento> { return this.g.criar(cmd); }
}
export class ConfirmarAgendamento implements ConfirmarAgendamentoUseCase {
  constructor(private readonly g: AgendamentoGateway) {}
  execute(id: string): Promise<Agendamento> { return this.g.confirmar(id); }
}
export class MarcarAgendamentoRealizado implements MarcarAgendamentoRealizadoUseCase {
  constructor(private readonly g: AgendamentoGateway) {}
  execute(id: string): Promise<Agendamento> { return this.g.marcarRealizado(id); }
}
export class MarcarAgendamentoNoShow implements MarcarAgendamentoNoShowUseCase {
  constructor(private readonly g: AgendamentoGateway) {}
  execute(id: string): Promise<Agendamento> { return this.g.marcarNoShow(id); }
}
export class CancelarAgendamento implements CancelarAgendamentoUseCase {
  constructor(private readonly g: AgendamentoGateway) {}
  execute(id: string, cmd: CancelarAgendamentoCommand): Promise<Agendamento> { return this.g.cancelar(id, cmd); }
}
